import { render, staticRenderFns } from "./UploadCard.vue?vue&type=template&id=f347fa4e&scoped=true&"
import script from "./UploadCard.vue?vue&type=script&lang=js&"
export * from "./UploadCard.vue?vue&type=script&lang=js&"
import style0 from "./UploadCard.vue?vue&type=style&index=0&id=f347fa4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f347fa4e",
  null
  
)

export default component.exports